import { useEffect, useRef, useState } from "react";
import './styles/gallery.intro.css';

function IntroSection() {
  const introRef = useRef(null);
  const [startTyping, setStartTyping] = useState(false);
  const typingText = "고객을 생각합니다 ";
  const [typed, setTyped] = useState("");
  const [index, setIndex] = useState(0);

  /* 스크롤 감지 */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartTyping(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (introRef.current) observer.observe(introRef.current);
    return () => observer.disconnect();
  }, []);

  /* 타이핑 */
  useEffect(() => {
    if (!startTyping) return;
    if (index < typingText.length) {
      const timer = setTimeout(() => {
        setTyped((prev) => prev + typingText[index]);
        setIndex(index + 1);
      }, 80);
      return () => clearTimeout(timer);
    }
  }, [index, startTyping]);

  return (
    <section className="intro" ref={introRef}>
      <h2 className="typing">
        {typed.startsWith("고객을") ? (
          <>
            <span className="highlight">고객을</span>
            {typed.slice(3)}
          </>
        ) : (
          typed
        )}
      </h2>

      <p className={`fade ${startTyping ? "active" : ""}`}>
        정진냉동은 각종 냉장·냉동 설비 및 장치의 문제로 인해 발생하는<br />
        고객님의 불편과 영업 손실을 최대한 신속하게 해소하는 것을 목표로 합니다.<br />  
        정확한 진단과 책임 있는 작업, 그리고 신뢰를 최우선 가치로 삼아<br />  
        언제나 믿고 맡길 수 있는 서비스를 제공하겠습니다.
      </p>
    </section>
  );
}

export default IntroSection;